import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "cx-language-picker dropdown" }
const _hoisted_2 = {
  class: "btn dropdown-toggle",
  type: "button",
  id: "language",
  "data-toggle": "dropdown",
  "aria-expanded": "true"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "caret" }, null, -1)
const _hoisted_4 = {
  class: "dropdown-menu",
  role: "menu",
  "aria-labelledby": "dropdownMenu1"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("button", _hoisted_2, [
      _createVNode("span", null, _toDisplayString(_ctx.translations.language), 1),
      _hoisted_3
    ]),
    _createVNode("ul", _hoisted_4, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.availableLanguages, (language) => {
        return (_openBlock(), _createBlock("li", {
          key: language.code
        }, [
          _createVNode("div", {
            class: "dropdown-menu__item",
            onClick: $event => (_ctx.$emit('languageChanged', language))
          }, [
            _createVNode("span", null, _toDisplayString(language.name), 1),
            _createVNode("img", {
              class: "flags",
              src: language.src
            }, null, 8, ["src"])
          ], 8, ["onClick"])
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}